import React from "react";
import Home from "./Home";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./App.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return <Home />;
}

export default App;
